import { ReactElement } from 'react';

import { useQuery } from '@tanstack/react-query';

import { API } from ':api';
import { SHOWCASE_INFO } from ':api/urls';
import { Preloader, ErrorPage } from ':components';
import { ShowcaseContext, IShowcaseInfo } from ':constants';

interface IShowcaseProviderProps {
  children: ReactElement;
}

export const ShowcaseProvider = ({
  children,
}: IShowcaseProviderProps): ReactElement => {
  const { data, isLoading, error } = useQuery<IShowcaseInfo>({
    queryKey: ['showcaseInfo'],
    queryFn: async () => {
      const { data: result } = await API.get(SHOWCASE_INFO);
      if (typeof result !== 'object') {
        throw new Error(`Cannot parse showcase data: ${result}`);
      }
      return result;
    },
  });

  if (isLoading) {
    return <Preloader text='Загружаем важную информацию' />;
  }

  if (!data || error) {
    return <ErrorPage />;
  }

  return (
    <ShowcaseContext.Provider value={data}>{children}</ShowcaseContext.Provider>
  );
};
